// extracted by mini-css-extract-plugin
export var isWide = "textElement-module--isWide--lzV3f";
export var textElement = "textElement-module--textElement--G-pZ5";
export var textElementWide = "textElement-module--textElementWide--5aQBQ";